import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { API_CALLS } from "../../../../../../API/api_calls";
import {
  actions,
  useAppDispatch,
  useAppSelector,
} from "../../../../../../redux";
import { FlexRowEnd } from "../../../../../Common/Styles";
import CircleModalProps from "./CircleModal";

const ModalFooter = ({
  circleName,
  setIsSuccessModal,
  color,
}: CircleModalProps.ModalFooterProps) => {
  const dispatch = useAppDispatch();
  const { editCircleId, listOfCircles } = useAppSelector(
    (state) => state.circle
  );
  const editCircle = listOfCircles.find((circle) => circle.id === editCircleId);
  return (
    <Container>
      {editCircleId && (
        <Components.Button
          color="Neutral"
          disabled={false}
          label="Cancel"
          onClick={() => {
            dispatch(
              actions.circle.setCreateCircleOpen({ createCircleOpen: false })
            );
          }}
          size="Medium"
          kind="Primary"
        />
      )}
      <Components.Button
        color="Primary"
        kind="Primary"
        disabled={
          circleName.length === 0 ||
          (editCircle?.name === circleName && editCircle?.colour === color)
        }
        label={editCircleId ? "Save" : "Create"}
        onClick={() => {
          (editCircleId
            ? API_CALLS.CIRCLE.updateCircle({
                colour: color,
                name: circleName,
                id: editCircleId,
              })
            : API_CALLS.CIRCLE.createCircle({
                colour: color,
                name: circleName,
              })
          ).then(() => setIsSuccessModal(true));
        }}
        size="Medium"
      />
    </Container>
  );
};

export default ModalFooter;
const Container = styled(FlexRowEnd)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
